import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state={
    userInfo:null,
    loginDailogShow:false,
    token:null,
};
const getters={

};
const mutations = {//commit
    resetUserState(state){
        state.userInfo=null;
    },
    updateState(state,data){
        state.userInfo=data;
    },
    modifyLoginDailogShow(state,data){
        state.loginDailogShow=data;
    },
    modifyToken(state,data){
        state.token=data;
    },
};
const actions={//dispatch

};

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions
})
